import React from 'react';

/** Instant press feedback shared by every tappable row and button (spec §8). */
export const PRESS = 'active:scale-[0.97] transition-transform duration-100 motion-reduce:transition-none';

/** Uppercase grey section header above an inset group. */
export function SectionHeader({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="px-4 pb-1.5 text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-zinc-400">
      {children}
    </h3>
  );
}

/** Inset grouped list: rounded white (dark: zinc) group with hairline separators. */
export function InsetGroup({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={`overflow-hidden rounded-2xl bg-white dark:bg-zinc-900 divide-y divide-slate-200 dark:divide-zinc-800 ${className}`}
    >
      {children}
    </div>
  );
}

export type PillTone = 'rose' | 'amber' | 'emerald' | 'slate';

const PILL_TONES: Record<PillTone, string> = {
  rose: 'bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300',
  emerald: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300',
  slate: 'bg-slate-100 text-slate-600 dark:bg-zinc-800 dark:text-zinc-300',
};

/** Text pill: colour is never the only signal, so `children` is required. */
export function Pill({ tone, children }: { tone: PillTone; children: string }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-semibold leading-tight ${PILL_TONES[tone]}`}
    >
      {children}
    </span>
  );
}
